/**
 * Composable per il reset centralizzato delle stores Pinia
 * Utilizzato durante logout e impersonazione per pulire i dati utente-specifici
 */

export const useStoreReset = () => {
  /**
   * Reset di tutte le stores che contengono dati utente-specifici
   */
  const resetAllStores = () => {
    try {
      // Reset delle stores principali
      const activityStore = useActivityStore()
      const marketplaceStore = useMarketplaceStore()
      const catalogStore = useCatalogStore()
      const userStore = useUserStore()

      // Reset dei dati nelle stores che non hanno $reset nativo
      // Activity Store
      activityStore.userActivities = null
      activityStore.types = null
      activityStore.typesList = undefined

      // Marketplace Store
      marketplaceStore.userContents = undefined
      marketplaceStore.networkContents = undefined
      marketplaceStore.cityList = undefined
      marketplaceStore.categories = undefined
      marketplaceStore.services = []
      marketplaceStore.items = []
      marketplaceStore.pending = 0

      // Catalog Store
      catalogStore.userCatalogs = []
      catalogStore.catalogs = []
      catalogStore.services = []

      // User Store
      userStore.data = undefined
      userStore.autoUpdateClient = false

      // Reset di altre stores se presenti
      try {
        const calendarStore = useCalendarStore()
        calendarStore.$reset?.()
      } catch {
        // Store non disponibile o non ha $reset
      }

      try {
        const rateStore = useRateStore()
        rateStore.$reset?.()
      } catch {
        // Store non disponibile o non ha $reset
      }

      try {
        const resourceStore = useResourceStore()
        resourceStore.$reset?.()
      } catch {
        // Store non disponibile o non ha $reset
      }

      try {
        const serviceCategoryStore = useServiceCategoryStore()
        serviceCategoryStore.$reset?.()
      } catch {
        // Store non disponibile o non ha $reset
      }

      try {
        const slotStore = useSlotStore()
        slotStore.$reset?.()
      } catch {
        // Store non disponibile o non ha $reset
      }

      try {
        const stripeAccountStore = useStripeAccountStore()
        stripeAccountStore.userStripeAccounts = null
      } catch {
        // Store non disponibile o non ha $reset
      }

      console.log('✅ Stores reset completato')
    } catch (error) {
      console.error('❌ Errore durante il reset delle stores:', error)
    }
  }

  /**
   * Reset specifico per il logout completo
   */
  const resetForLogout = () => {
    resetAllStores()
  }

  /**
   * Reset specifico per l'impersonazione
   * Non pulisce localStorage/sessionStorage ma solo le stores
   */
  const resetForImpersonation = () => {
    resetAllStores()
  }

  return {
    resetAllStores,
    resetForLogout,
    resetForImpersonation,
  }
}
